import React from "react";
import { Typography, Box, CircularProgress } from "@mui/material";
import { getIconComponent } from "@/Utils/getIconComponent"; // ✅ Make sure you have this utility

export default function TypographyText({
  label = "",
  actionText = "",
  onClick,
  loading = false,
  disabled = false,
  width = "auto",
  height = "auto",
  variant = "body",
  actionTextColor = "var(--gray-800)",
  sx = {},
  actionTextSx = {}, // ✅ New prop for actionText styling
  icon = "", // ✅ Added
  iconColor = "var(--brand-800)", // ✅ Default red
}) {
  const isClickable = !loading && !disabled;
  const showActionText = Boolean(actionText);

  const StartIcon = icon
    ? getIconComponent(icon, {
        color: iconColor, // ✅ red by default
        size: 22,
      })
    : null;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: showActionText ? "flex-start" : "flex-end",
        alignItems: "center",
        gap: 1,
        width,
        height,
        ...sx,
      }}
    >
      {StartIcon && <Box pt={"6px"}>{StartIcon}</Box>}
      {showActionText && (
        <Typography
          variant={variant}
          sx={{
            color: actionTextColor || "var(--gray-800)",
            ...actionTextSx,
          }}
        >
          {actionText}
        </Typography>
      )}
      <Typography
        variant="bodyMedium"
        onClick={isClickable ? onClick : undefined}
        sx={{
          color: disabled || loading ? "var(--gray-500)" : "var(--link-blue)",
          cursor: disabled || loading ? "not-allowed" : "pointer",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          opacity: disabled ? 0.6 : 1,
        }}
      >
        {label}
        {loading && (
          <CircularProgress
            size={14}
            sx={{ color: "var(--brand-800)" }} // 🔥 spinner color
          />
        )}
      </Typography>
    </Box>
  );
}
